import HlpLazyLoadModal from "@Helpers/functions/lazyLoadModal";

import { logError } from "@Helpers/logger";
import { sleep } from "@Helpers/support";

import useLegacyStore from "@Composables/useLegacyStore";
import useNotify from "@Composables/useNotify";

export default function useSurvey() {
  const { getters } = useLegacyStore();
  const { notifyError } = useNotify();

  const fetchSurvey = (url, section) => {
    if (!isSurveyVisible(section)) return;

    axios
      .get(url, { DISABLE_ERROR_INTERCEPTORS: true })
      .then((result) => {
        const modal = HlpLazyLoadModal("survey/TinyurlSurvey");
        const questions = result.data.data;

        // make sure previous modal are already closed/destroyed
        sleep(500).then(() => {
          Bus.$emit("showModal", modal, { questions }, {}, {}, true);
        });
      })
      .catch((error) => {
        // return the API error to handle specifically
        if (error.response) throw error;

        // show generic notification on mechanical error
        notifyError();
        logError("Unable to load survey: " + error.message);
      });
  };

  const isSurveySkipped = (section) => {
    section = _.startCase(section);
    return localStorage.getItem(`isSurvey${section}Skipped`) === "true";
  };

  const isSurveyVisible = (section) => {
    const isUserLoggedIn = getters.isUserLoggedIn;
    const isPastDue = getters.getUserCurrentSubscription?.isPastDue;

    if (!isUserLoggedIn || isPastDue) return false;
    return !isSurveySkipped(section);
  };

  return { fetchSurvey, isSurveySkipped };
}
